module.exports = __webpack_public_path__ + "static/img/qr_01.884354c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mobile/common/qr_01.jpg
// module id = 122
// module chunks = 0